import Rete from 'rete';

import { distSocket } from './index';

import TextControl from './TextControl';


export default class OutputComponent extends Rete.Component {

	constructor() {
		super("Output");
		this.path = ["Module"];
		this.contextMenuName = "Output";
		this.module = {
			nodeType: 'output',
			socket: distSocket
		}
	}

	builder(node) {
		let inp = new Rete.Input('input', "Input", distSocket);
		let ctrl = new TextControl(this.editor, 'name');

		ctrl.component.methods.onChange = () => {
			node.update();
		}

		return node.addControl(ctrl).addInput(inp);
	}
}
